(function ($) {
   // The .js-pdppack carousel is now pmd-slider, built server-side in
   // sections/pmd-product-packcarousel.liquid along with its own nav buttons.
   // The Slick initialisation that used to live here has been removed.

   $(".PDPradio-overlay input").change(function() {
      if($(this).prop("checked") == true){
        $(".PDPradio-overlay input").closest('.PDPAlternate-variant').removeClass('is-selected')
        $(this).closest('.PDPAlternate-variant').addClass('is-selected')
      }
    })

})(jQuery);


$('.js-product-qty-controls-pdpa').on('click', function(evt) {

    const button = $(evt.delegateTarget)
    var action = button.attr('data-action')
    var field = $('.js-qty-indicator-pdpa')

    var  currentQty = parseInt(field.val())

     updatedQty = (function() {
        if (action === 'plus') {
          return 1 + currentQty
        }
        if (action === 'minus' && currentQty > 1) {

          return currentQty - 1
        }
        return currentQty
      })()

      field.val(updatedQty)
})

/*
$('.js-recharge-fakeautodeliver').hover(function(evt) {
    evt.preventDefault()
  $('.rc_popup__block').css("display", "block");
})

$('.js-recharge-fakeautodeliver').mouseleave(function(evt) {
    evt.preventDefault()
      $('.rc_popup__block').css("display", "none");
})
*/
$('.js-recharge-fakeautodeliver').on('click', function(evt) {
  evt.preventDefault()
  $('.rc_label__autodeliver').click()
  $('#AddToCart').click()
})

$('.js-recharge-fakeonetime').on('click', function(evt) {
  evt.preventDefault()
  $('.rc_label__onetime').click()
  $('#AddToCart').click()
})


$(document).ready(function(){
    $('#rc_radio_options input[type="radio"]').change(function(){
        var $this = $(this);
        // Only remove the class in the specific `box` that contains the radio
        $this.closest('#rc_radio_options').find('.rc_block__type').removeClass('highlight');
        $this.closest('.rc_block__type').addClass('highlight');
    });
});
// Gallery sync. The gallery is pmd-slider now (was Flickity via the legacy
// theme.js), so these two events drive it through the component API instead of
// jQuery.data('flickity'). The buy box still dispatches both events unchanged.
function pmdGallery() {
  var container = document.getElementById('ProductPhoto');
  return container ? container.querySelector('pmd-slider') : null;
}

// Slide to the media whose alt text mentions the selected variant value.
document.addEventListener('slideToVariantImage', function (e) {
  var variantValue = (e && e.detail && e.detail.variant_value) || null;
  if (!variantValue) return;

  var slider = pmdGallery();
  if (!slider) return;

  var slides = Array.prototype.slice.call(
    slider.querySelectorAll('pmd-slide:not([cloned])')
  );
  var needle = variantValue.toLowerCase();
  var matchIndex = -1;

  for (var i = 0; i < slides.length; i++) {
    var img = slides[i].querySelector('img[alt]');
    var alt = img ? (img.getAttribute('alt') || '') : '';
    if (alt && alt.toLowerCase().indexOf(needle) !== -1) {
      matchIndex = i;
      break;
    }
  }

  if (matchIndex < 0) return;
  slider.scrollToIndex(matchIndex);
});

// Slide to a specific media id.
document.addEventListener('changeSlider', function (e) {
  var mediaId = (e && e.detail && e.detail.media_id) || null;
  if (!mediaId) return;

  var slider = pmdGallery();
  if (!slider) return;

  var slides = Array.prototype.slice.call(
    slider.querySelectorAll('pmd-slide:not([cloned])')
  );
  var targetIndex = -1;

  for (var i = 0; i < slides.length; i++) {
    if (slides[i].getAttribute('media-id') === String(mediaId)) {
      targetIndex = i;
      break;
    }
    if (slides[i].querySelector('[data-src="' + mediaId + '"]')) {
      targetIndex = i;
      break;
    }
  }

  if (targetIndex < 0) return;
  slider.scrollToIndex(targetIndex);
});
